export default __webpack_public_path__ + "static/media/writing.a54478f3.svg";